import {lazy} from '@aboutyou/lazy-imports';

export const ConsentBannerFocusManagement = lazy(() =>
  import('./ConsentBannerFocusManagement.eager').then(mod => ({
    default: mod.ConsentBannerFocusManagement,
  })),
);
